var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0856 0.669922C8.94319 0.669922 0.720703 8.87825 0.720703 19.0033C0.720703 29.1283 8.94319 37.3366 19.0856 37.3366C29.2281 37.3366 37.4506 29.1283 37.4506 19.0033C37.4506 8.87825 29.2281 0.669922 19.0856 0.669922ZM27.046 15.9033C27.1926 15.736 27.3042 15.5412 27.3742 15.3302C27.4443 15.1192 27.4713 14.8964 27.4538 14.6749C27.4363 14.4533 27.3746 14.2375 27.2724 14.0401C27.1701 13.8427 27.0293 13.6678 26.8583 13.5255C26.6872 13.3832 26.4895 13.2765 26.2765 13.2117C26.0636 13.1469 25.8398 13.1252 25.6184 13.148C25.3969 13.1707 25.1823 13.2375 24.987 13.3443C24.7918 13.4511 24.62 13.5958 24.4816 13.7699L17.3026 22.3683L13.5878 18.6583C13.273 18.3547 12.8512 18.1867 12.4135 18.1905C11.9757 18.1943 11.557 18.3695 11.2475 18.6786C10.9379 18.9876 10.7623 19.4056 10.7585 19.8426C10.7547 20.2796 10.923 20.7006 11.2271 21.0149L16.2357 26.0149C16.3998 26.1786 16.5962 26.3063 16.8124 26.39C17.0287 26.4737 17.26 26.5115 17.4917 26.501C17.7234 26.4905 17.9503 26.4319 18.1581 26.329C18.3658 26.2261 18.5498 26.0811 18.6983 25.9033L27.046 15.9033Z",
    fill: "#079F9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveStep);
export default __webpack_public_path__ + "static/media/activeStep.98feb683ccc22be6c8f5fd8cbc898d6a.svg";
export { ForwardRef as ReactComponent };